/**
 * 教育行业
 */
import React from 'react';
import SkeletonNew from 'components/solution/skeletonNew';
import { headBg, headBgM, challenge, frameSrc, frameSrcM, frame, advantage, scene, caseList } from 'constants/solution/edu-solution';

const Education = () => {
  return (
    <SkeletonNew
      headFixed={true}
      challenge={challenge}
      caseList={caseList}
      advantage={advantage}
      scene={scene}
      frame={frame}
      headBg={headBg}
      headBgM={headBgM}
      title="教育行业解决方案"
      simpleDesc="蓝天下 · 同课堂"
      desc={`教育全融合视频互动解决方案，以云视频互动技术为核心，实现互动教学、同步课\n堂、远程教研、督导巡课、视频会议、考场监控、校园安全等智慧教育场景的融合应\n用，为教育用户构建教、学、研、管、评及组织办公协同的一站式音视频应用生态体\n系，促进教育优质均衡发展，实现“蓝天下·同课堂”。`}
      pageTitle="教育行业"
      tdkWord="eduSolution"
      frameSrc={frameSrc}
      frameSrcM={frameSrcM}
    />
  );
};

export default Education;
